export const SET_DATA_QR = 'SET_DATA_QR'
export const SET_ERROR_QR = 'SET_ERROR_QR'

export const SET_DATA_CLIENTE = 'SET_DATA_CLIENTE'